module.exports = __webpack_public_path__ + "img/email.d3c3edad.svg";